// ================================================================================================
import { Component, ReactNode, CSSProperties } from 'react';
import "./ListLite.less";
import { isDefined, IsNullOrWhiteSpace } from "../../../Utils/Micro";
import Tippy from '@tippyjs/react';
// ================================================================================================
interface ListItemProps {
    /**
     * Define the level of the item
     */
    groupLevel: number;

    /**
     * Primary text
     */
    primaryText: string;

    /**
     * Secondary text 
     */
    secondaryText?: string;

    /**
     * Tooltip 
     */
    tooltip?: string;

    /**
     * Right item 
     */
    rightItem?: ReactNode;
    rightItemStyle?: CSSProperties;
    rightItemInSeperateLine?: boolean;

    /**
     * Hide the second line and have the user to un-hide it
     */
    rightItemHide?: boolean;

    /**
     * Left item
     */
    leftItem?: ReactNode;

    /**
     * Extra css styles
     */
    style?: CSSProperties;

    /**
     * Text Area style
     */
    textStyle?: CSSProperties;
}
// ------------------------------------------------------------------------------------------------
interface ListItemState {
    /**
     * In the case tha the item is 2 lines and you need to hide it
     */
    isOpen?: boolean;
}
// ------------------------------------------------------------------------------------------------
export class ListLiteItem extends Component<ListItemProps, ListItemState> {
    constructor(props: ListItemProps) {
        super(props);
        if (props.rightItemHide)
            this.state = { isOpen: false }
    }
    // --------------------------------------------------------------------------------------------
    onClickOpen = () => this.setState((s: ListItemState) => { s.isOpen = !s.isOpen; return s; })
    // --------------------------------------------------------------------------------------------
    render() {
        let props = this.props;
        const haveSecondLine = !props.rightItemHide || this.state.isOpen;
        const itemHeight = 36 * ((props.rightItemInSeperateLine && haveSecondLine) ? 2 : 1);
        const oneLineHeight = Math.floor(36 * ((props.rightItemInSeperateLine) ? 0.7 : 1));
        const rightItemWidth = 40;
        const leftIconWidth = 50;
        const level = props.groupLevel + 1;
        return <div
            id={(props.rightItemInSeperateLine) ? "item-two-line" : "item-one-line"}
            style={{
                paddingLeft: (level > 0) ? level * 16 : undefined,
                minHeight: itemHeight, ...props.style
            }}
        >
            <div
                id={"item-first-line"}
                style={{
                    minHeight: oneLineHeight,
                    cursor: props.rightItemHide ? "pointer" : null,
                    ...props.textStyle
                }}
                onClick={props.rightItemHide ? this.onClickOpen : undefined}
            >
                {
                    (isDefined(props.leftItem)) ?
                        <div
                            id="item-left"
                            style={{ height: oneLineHeight, width: leftIconWidth }}>
                            {props.leftItem}
                        </div> :
                        null
                }
                <div id="item-text" style={{ paddingRight: rightItemWidth + leftIconWidth }}>
                    {
                        (!IsNullOrWhiteSpace(props.tooltip)) ?
                            <Tippy
                                animation={false}
                                placement="bottom"
                                content={props.tooltip}
                            >
                                <div id="item-primary" >
                                    {props.primaryText}
                                </div>
                            </Tippy> :
                            <div id="item-primary" >
                                {props.primaryText}
                            </div>
                    }
                    {
                        (!IsNullOrWhiteSpace(props.secondaryText)) ?
                            <div id="item-secondary">
                                {props.secondaryText}
                            </div> :
                            null
                    }
                </div>
                {
                    (props.rightItemHide && props.rightItemInSeperateLine) ?
                        <div
                            style={{ height: oneLineHeight, width: 40, fontSize: 18, cursor: "pointer" }}
                            id="item-right">
                            <i className={"fa " + ((this.state.isOpen) ? "fa-angle-down" : "fa-angle-left")} />
                        </div>
                        : null
                }
            </div>
            {
                (haveSecondLine) ?
                    <div
                        id={(props.rightItemInSeperateLine) ? "item-bottom" : "item-right"}
                        style={{ ...props.rightItemStyle }}
                    >
                        {props.rightItem}
                    </div>
                    : null
            }
        </div>
    }
    // --------------------------------------------------------------------------------------------
}
// ------------------------------------------------------------------------------------------------
export var ListLite = (props: { style: CSSProperties, children?: ReactNode, className?: string }) => {
    return <div className={"list-lite " + props.className} style={props.style}>
        {props.children}
    </div>
}
// ------------------------------------------------------------------------------------------------